import fr from './fr.json';
import en from './en.json';
import br from './br.json';

export const resources = {
  fr: { translation: fr },
  en: { translation: en },
  br: { translation: br },
};

export interface Language {
  code: string;
  name: string;
  flag?: string;
  flagImg?: string;
}

export const languages: Language[] = [
  { code: 'br', name: 'Brezhoneg', flagImg: '/bretagne.png' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

export default resources;
